import React, { useEffect, useRef } from 'react';

const AnimatedSection = ({ children, className = '', animation = 'reveal', threshold = 0.15, delay = 0, style = {} }) => {
  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            element.classList.add('revealed');
          }, delay);
          observer.unobserve(element);
        }
      },
      { threshold }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [threshold, delay]);

  return (
    <div ref={ref} className={`${animation} ${className}`} style={style}>
      {children}
    </div>
  );
};

export default AnimatedSection;
